<template>
  <div class="grid grid-cols-2 lg:grid-cols-4 2xl:grid-cols-6 gap-0">
    <div v-for="product in products" :key="product.id">
      <selling-product-card :handle="handle" :product="product"
                            @product-selected="(args) => emit('product-selected', args)"/>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type {Product} from "~/models/product";

const emit = defineEmits<{
  'product-selected': [payload: { product: Product, handle: string }]
}>()

const {products, handle} = defineProps<{
  products: Product[],
  handle: string
}>()
</script>